import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router, RoutesRecognized } from '@angular/router';
import { PopoverDirective } from 'ngx-smart-popover';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { ContactUsComponent } from './components/contact-us/contact-us.component';
import { ForgetPasswordComponent } from './components/forget-password/forget-password.component';
import { LoginPopupComponent } from './components/login-popup/login-popup.component';
import { Feeds } from './models/feeds';
import { LoaderService } from './service/loaderService';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit{
  title = 'vaadude';

  userName = "EdberkDavi";

  FEEDS = "feeds";
  QUESTIONS = "questions";
  JOB_OPENINGS = "jobOpenings";

  selectedMenu = this.FEEDS;

  showtopmenu:boolean = false;
  dialogRef: any;

  constructor(
    private router:Router,
    public loader:LoaderService,
    public matDialog: MatDialog,
  ){
    console.log(router)
    this.router.events.subscribe((event) => {  
      if (event instanceof RoutesRecognized) {  
        console.log(event.url)
        if(event.url.includes("home")){
               this.showtopmenu = false;
          }else if(event.url =="/"){
                  this.showtopmenu = false;
          }else if(event.url.includes("userList")){
                  this.showtopmenu = false;
          }
          else{
                  this.showtopmenu = true;
          }


        if(event.url.includes("jobOpenings")){
          this.selectedMenu = this.JOB_OPENINGS;
        }else if(event.url.includes("feeds")){
          this.selectedMenu = this.FEEDS;
        } else if(event.url.includes("techquestion")){
          this.selectedMenu = this.QUESTIONS;
        }


      }})


  }



  @ViewChild('myPopover')
  private popover:any ;

  ngOnInit(): void {
   this.checkStatusAndSetUserName();
  }

  checkStatusAndSetUserName(){
    if (this.getIsLoggedIn()) {
      if(localStorage.getItem("userName")!= undefined) {

      let userName :any; 
      userName = localStorage.getItem("userName");
      if(userName != null && userName != undefined && userName != ""){
       this.userName = userName;
      }
      }
      
    }

  }

  goToDashboard(){
    // window.location.reload();

    try {
      if(this.popover != undefined){
        this.popover.hide();
    } 
    } catch (error) {
      console.log(error);
    }


    this.router.navigateByUrl("home")
  }

  goToUserList(){
    // window.location.reload();

    try {
      if(this.popover != undefined){
        this.popover.hide();
    } 
    } catch (error) {
      console.log(error);
    }
 
    this.router.navigateByUrl("userList")
  }

  homePage(){
    this.router.navigateByUrl("home")
  }



  getUserNameForProfile():string{
      return this.userName.charAt(0).toUpperCase() + this.userName.charAt(1).toUpperCase();
  }
  goToLogin(){
 if(this.title) {
      this.openLoginPopUp();
      return;
    }
  }
  goToFeeds(){
   
       this.selectedMenu = this.FEEDS
   try {
      if(this.popover != undefined){
        this.popover.hide();
    } 
    } catch (error) {
      console.log(error);
    } 
       this.router.navigateByUrl("feeds")
  }

  goToTechQuestions(){
    this.selectedMenu = this.QUESTIONS
      this.router.navigateByUrl("techquestions")
    
  }

  goToJobOpening(){
    this.selectedMenu = this.JOB_OPENINGS
      this.router.navigateByUrl("jobOpenings")
  }

  checkSelectedMenu(menu:string):boolean{
       if(menu == this.selectedMenu){
         return true;
       }
       return false;
  }

  openLoginPopUp() {
    this.dialogRef = this.matDialog.open(LoginPopupComponent, {
      width: '25vw',
      disableClose: false,
      panelClass:"loginpopup",
      data: {

      }
    })

    this.dialogRef.afterClosed().subscribe((result: any) => {
      if(result == 'Custom_Forgot_Password'){
        this.openFgtPwdPop(false);
        return;
      }
      let userName :any; 
      userName = localStorage.getItem("userName");
      if(userName != null && userName != undefined && userName != ""){
       this.userName = userName;
      }
    });
  }

  openFgtPwdPop(isFgtPwd: any) {
    let dialogRefer = this.matDialog.open(ForgetPasswordComponent, {
      width: '25vw',
      disableClose: false,
      data: {
        isChangePwd: isFgtPwd,
      }
    })
    dialogRefer.afterClosed().subscribe((result: any) => {
      if(result){
        this.openPwdUpdate();
      }
    });
  }

  openPwdUpdate() {
    let diaRef = this.matDialog.open(ForgetPasswordComponent, {
      width: '25vw',
      disableClose: false,
      data: {
        isChangePwd: true,
      }
    })
  }

  getIsLoggedIn():boolean {
    if(localStorage.getItem("isAuthenticated")!= undefined && localStorage.getItem("isAuthenticated") == "true") {
      return true;
    }
    return false;
  }

  getIsAdmin():boolean {
    if(localStorage.getItem("userType")!= undefined && localStorage.getItem("userType") == "Admin") {
      return true;
    }
    return false;
  }

  logout(){
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("userId");
    localStorage.removeItem("userName");
    this.router.navigateByUrl("home");
    if(this.popover != undefined){
      this.popover.hide();
    }
  }


  openAboutUsPopup() {
    this.dialogRef = this.matDialog.open(AboutUsComponent, {
    })
  }

  openContactUsPopup() {
    this.dialogRef = this.matDialog.open(ContactUsComponent, {
    })
  }

}
